import { useState } from "react";
import { flagEmoji } from "../lib/flag";

/**
 * Country flag as a small image (public/flags/<cc>.webp, founder-provided set). Windows has no flag emoji, so the
 * emoji showed as two letters ("US"); the image fixes that everywhere. Unknown country: the neutral globe emoji.
 * A missing image falls back to the emoji. Decorative: the country is not announced (names stay the accessible text).
 */
export function FlagIcon({ code, height = 16 }: { code: string | null | undefined; height?: number }) {
  const valid = typeof code === "string" && /^[A-Z]{2}$/.test(code);
  const [failed, setFailed] = useState(false);
  if (!valid || failed) return <span aria-hidden="true">{flagEmoji(valid ? code : null)}</span>;
  return (
    <img
      className="flag-icon"
      src={`/flags/${code.toLowerCase()}.webp`}
      alt=""
      aria-hidden="true"
      height={height}
      style={{ height, width: "auto", verticalAlign: "-2px", borderRadius: 2 }}
      onError={() => setFailed(true)}
      decoding="async"
    />
  );
}
